<form [formGroup]="formGroup">
    @if (!!paramsValue) {
        <div class="param-form-item form-item">
            @if (paramsValue.paramType === 'Boolean') {
                <mat-checkbox class="accent-button" matInput formControlName="param" (change)="checkboxChanged($event)">{{ paramsValue.paramName }}</mat-checkbox>
            } @else {
                <mat-form-field>
                    <mat-label>{{ paramsValue.paramName }}</mat-label>
                    @if (paramsValue.paramType === 'Text') {
                        <input matInput type="text" formControlName="param" autocomplete="off" class="hierarchy-input" (input)="paramsValueUpdated($event.target.value)" required />
                    } @else if (paramsValue.paramType === 'Number') {
                        <input
                            matInput
                            type="number"
                            formControlName="param"
                            autocomplete="off"
                            class="hierarchy-input"
                            (input)="paramsValueUpdated($event.target.value)"
                            required />
                    } @else if (paramsValue.paramType === 'Date') {
                        <input
                            matInput
                            formControlName="param"
                            [matDatepicker]="dp"
                            autocomplete="off"
                            class="hierarchy-input"
                            required
                            (dateChange)="dateValueChange($event)"
                            (dateInput)="dateValueChange($event)" />
                        @if (disabled === false) {
                            <mat-datepicker-toggle class="form-item" matSuffix [for]="dp"></mat-datepicker-toggle>
                        }
                    }

                    <mat-datepicker #dp></mat-datepicker>
                </mat-form-field>
            }

            <app-inheritance-info [id]="paramsValue.paramName" [disabled]="disabled" [isInherited]="paramsValue.isInherited" [parentValue]="parentValue"></app-inheritance-info>
            @if (disabled === false) {
                <a class="contextual-menu-icon" #menuTrigger="matMenuTrigger" [matMenuTriggerFor]="appMenu" (click)="$event.stopPropagation(); menuTrigger.openMenu()">
                    <mat-icon matTooltip="Afficher le menu">more_vert</mat-icon>
                </a>
            }
        </div>
    }
</form>

<mat-menu #appMenu="matMenu" class="contextual-menu">
    @if (parentValue) {
        <a class="parameter-menu-item" (click)="setInheritedValue()">
            <fa-icon [icon]="faSitemap" class="fas parameter-menu-icon" matTooltip="Hériter de la valeur de l'organisation parente"></fa-icon>
            <span>Valeur héritée</span>
        </a>
    }
    <a class="parameter-menu-item" (click)="setDefaultValue()">
        <fa-icon [icon]="faCog" class="fas parameter-menu-icon" matTooltip="Utiliser la valeur par défaut"></fa-icon>
        <span>Valeur par défaut</span>
    </a>
</mat-menu>
